import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { MyPageSettingsPageLayout } from '../features/my-page-settings/ui/my-page-settings-page-layout';
import { MyPageSettingsPersonalDataScreen } from '../features/my-page-settings/ui/my-page-settings-personal-data-screen';
import { getEmployeeProfile } from '../shared/api/employee.service';

export function MyPageProfilePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const profileQuery = useQuery({
    queryFn: getEmployeeProfile,
    queryKey: ['employee', 'profile'],
  });
  const profile = profileQuery.data ?? null;
  const screenKey = profile?.updatedAt ?? 'profile-loading';

  return (
    <MyPageSettingsPageLayout
      backAriaLabel={t('myPage.backAria')}
      frameDataUi="settings-personal-data-frame"
      onBack={() => {
        navigate('/settings');
      }}
      onOpenHome={() => {
        navigate('/home');
      }}
      onOpenMyPage={() => {
        navigate('/my-page');
      }}
      pageDataUi="settings-personal-data"
      title={t('myPageSettings.profile.title')}
    >
      <MyPageSettingsPersonalDataScreen
        key={screenKey}
        initialProfile={profile}
        onComplete={() => {
          navigate('/settings');
        }}
      />
    </MyPageSettingsPageLayout>
  );
}
